import React from 'react';
import { DataGridEnumTypeFilter, DataGridModFilter } from '../DataGridDocumentsEnumFilters';
import { Filter } from '../DataGridFilterMenu';
import { DataGridMultichipFilter, DataGridMultichipFilterPropTypes } from '../DataGridMultichipFilter';
import { DataGridStringFilter } from '../DataGridStringFilter';
import { FilterType } from './types/filterTypes';

interface FilterTypeSelectorProps extends DataGridMultichipFilterPropTypes {
  filterType: FilterType;
  onFilterChange: (filterValue: Filter) => void;
  columns: any[];
  columnOptions: string[];
}

export const FilterTypeSelector = (props: FilterTypeSelectorProps) => {
  const { filterType, filter, onFilterChange, columns, columnOptions, ...multichipProps } = props;

  const filterTypeSelected = (filterType: FilterType) => {
    switch (filterType) {
      case 'dataGridStringFilter':
        return <DataGridStringFilter filter={filter} onFilterChange={onFilterChange} />;
      case 'dataGridEnumTypeFilter':
        return (
          <DataGridEnumTypeFilter
            filter={filter}
            onFilterChange={onFilterChange}
            columns={columns}
            columnOptions={columnOptions}
          />
        );
      case 'dataGridMultichipFilter':
        return (
          <DataGridMultichipFilter
            filter={filter}
            onFilterChange={onFilterChange}
            columnOptions={columnOptions}
            {...multichipProps}
          />
        );
      case 'dataGridModFilter':
        return <DataGridModFilter filter={filter} onFilterChange={onFilterChange} />;
    }
  };

  return <>{filterTypeSelected(filterType)}</>;
};
